import { SafetySection } from "@/components/landing/SafetySection";

export default function Safety() {
  return (
    <div className="min-h-screen bg-background-cream font-roboto">
      <main>
        <SafetySection />
      </main>
    </div>
  );
}
